//! If changing the behavior of the scroll functions, make sure it also works in modal mode. (Set prop modal="true" in src/index.html.)
// Read readme for more information.

const findScrollContainer = (element: any) => {
  if (!element) {
    return window;
  }

  let parent = element.parentElement;
  while (parent) {
    const { overflow } = window.getComputedStyle(parent);
    if (overflow.split(' ').every((o) => o === 'auto' || o === 'scroll')) {
      return parent;
    }
    parent = parent.parentElement;
  }

  return window;
};

const scrollToElement = (
  searchWithin: Element | null,
  selector: string,
  block?: ScrollLogicalPosition
) => {
  const root =
    searchWithin ||
    (document.getElementsByTagName('hemfixare-calculator')[0]?.shadowRoot ??
      document);

  const element = root.querySelector(selector);
  const scrollContainer = findScrollContainer(element);

  if (element && scrollContainer) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: block ?? 'start',
      inline: 'nearest',
    });
  }
};

const scrollToNext = (target: HTMLElement) => {
  const next = target.closest('.calculator_card')?.nextElementSibling;
  const scrollContainer = findScrollContainer(next);

  if (next && scrollContainer) {
    const rect = next.getBoundingClientRect();
    if (scrollContainer instanceof HTMLElement) {
      const scrollContainerRect = scrollContainer.getBoundingClientRect();
      scrollContainer.scrollTo({
        top:
          scrollContainer.scrollTop +
          (rect.top - scrollContainerRect.top) -
          100,
        behavior: 'smooth',
      });
    } else {
      scrollContainer.scrollTo({
        top: rect.top + window.scrollY - 120,
        behavior: 'smooth',
      });
    }
  }
};

const scrollToPrev = (target: HTMLElement) => {
  const prev = target.closest('.calculator_card')?.previousElementSibling;
  const scrollContainer = findScrollContainer(prev);

  if (prev && scrollContainer) {
    const rect = prev.getBoundingClientRect();
    if (scrollContainer instanceof HTMLElement) {
      const scrollContainerRect = scrollContainer.getBoundingClientRect();
      scrollContainer.scrollTo({
        top:
          scrollContainer.scrollTop +
          (rect.top - scrollContainerRect.top) -
          100,
        behavior: 'smooth',
      });
    } else {
      // If scrollContainer is window
      scrollContainer.scrollTo({
        top: rect.top + window.scrollY - 120,
        behavior: 'smooth',
      });
    }
  }
};

export { scrollToElement, scrollToNext, scrollToPrev };
